import React, { createContext } from 'react';

const ProjectActionContext = createContext();

export default ProjectActionContext;